var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppTooltip',{scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("trigger")]},proxy:true}],null,true)},[_vm._v(" "),_c('div',{staticClass:"app-tooltip__content"},[_c('div',{staticClass:"app-tooltip__content-container"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }